var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "content-item" },
          [
            _c("text-input", {
              attrs: {
                label: "Example",
                name: "settingsExample",
                readonly: true,
                value: _vm.exampleFormattedDateTime
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content-item" },
          [
            _c(
              "flex-grid",
              [
                _c(
                  "flex-grid-item",
                  { attrs: { grow: "1" } },
                  [
                    _c("select-input", {
                      attrs: {
                        label: "Date format",
                        name: "settingsDateFormat",
                        options: _vm.dateFormatOptions,
                        value: _vm.modalDateFormat
                      },
                      on: { change: _vm.onDateFormatChange }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "flex-grid-item",
                  { attrs: { grow: "1" } },
                  [
                    _c("select-input", {
                      attrs: {
                        label: "Time format",
                        name: "settingsTimeFormat",
                        options: _vm.timeFormatOptions,
                        value: _vm.modalTimeFormat
                      },
                      on: { change: _vm.onTimeFormatChange }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "flex-grid-item",
                  { attrs: { grow: "1" } },
                  [
                    _c("select-input", {
                      attrs: {
                        label: "Timezone",
                        name: "settingsTimezone",
                        options: _vm.timezoneOptions,
                        value: _vm.modalTimezone
                      },
                      on: { change: _vm.onTimezoneChange }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("settings-footer", {
        attrs: { "submit-enabled": _vm.isSettingsChanged },
        on: { cancel: _vm.onClose, submit: _vm.onSubmit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15139d00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15139d00","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/settings-modal/components/settings-date-format.vue
// module id = 1570
// module chunks = 0